import { render, staticRenderFns } from "./paging-item.vue?vue&type=template&id=4f2028f2&scoped=true&"
import script from "./paging-item.vue?vue&type=script&lang=js&"
export * from "./paging-item.vue?vue&type=script&lang=js&"
import style0 from "./paging-item.vue?vue&type=style&index=0&id=4f2028f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2028f2",
  null
  
)

export default component.exports